import * as Scrivito from "scrivito";
import columnWidgetIcon from "assets/images/column_widget.svg";

Scrivito.provideEditingConfig("ColumnWidget", {
  title: "Column",
  thumbnail: columnWidgetIcon,
  hideInSelectionDialogs: true,
});
